import { adminAiGenerationQueryKeys as e } from "./adminAiGenerationQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminAiApi as n } from "@maat/api-ai";
//#region src/ai/admin/useAdminAiGenerationsQuery.ts
var r = (r = {}) => {
	let { intent: i, rating: a } = r;
	return t({
		queryKey: e.list(i, a),
		fetchPage: (e) => n.listGenerations({
			intent: i,
			rating: a,
			page: e
		}),
		key: "items"
	});
};
//#endregion
export { r as useAdminAiGenerationsQuery };
